import { render, staticRenderFns } from "./EducationalVideo.vue?vue&type=template&id=4602359c&scoped=true"
import script from "./EducationalVideo.vue?vue&type=script&lang=js"
export * from "./EducationalVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4602359c",
  null
  
)

export default component.exports